export default {
	title: 'scripts',
	components: [{ title: 'scripts', component: 'scripts_gen_2' }],
};
